import React from 'react';
import { NativeStackHeaderProps } from '@react-navigation/native-stack';

import { BaseMobileHeader } from './BaseMobileHeader';

export function Header(props: NativeStackHeaderProps) {
  return <BaseMobileHeader title={props.options.title} />;
}
